import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'age',
    standalone: true, 
    pure: true
})
export class AgePipe implements PipeTransform {

    transform(value: any): string {
        if (!value) return '';

        const dob = new Date(value);
        const today = new Date();

        let years = today.getFullYear() - dob.getFullYear();
        let months = today.getMonth() - dob.getMonth();
        const days = today.getDate() - dob.getDate();

        // Adjust month & year if birthday not reached yet this year
        if (days < 0) {
            months--;
        }
        if (months < 0) {
            years--;
            months += 12;
        }

        // Build Output Format
        let output = '';

        if (years > 0) {
            output += years === 1 ? '1 year' : `${years} years`;
        }

        if (months > 0) {
            if (output) output += ' '; // add space if years exist
            output += months === 1 ? '1 month' : `${months} months`;
        }

        // If both 0
        if (!output) output = '0 months';

        return output;
    }
}
